/**
 * Game constants and configuration values
 */

// Game rules
export const MAX_STRIKES = 3;

// Strike threshold - decreases with level for progressive difficulty
export const INITIAL_STRIKE_THRESHOLD = 50; // pixels at level 1
export const STRIKE_THRESHOLD_DECREASE_INTERVAL = 5; // every 5 levels
export const STRIKE_THRESHOLD_DECREASE_AMOUNT = 5; // pixels
export const MIN_STRIKE_THRESHOLD = 25; // minimum pixels

// Scoring - ratio INCREASES with level (inverted for harder scoring)
export const PERFECT_SCORE = 100;
export const BASE_PIXEL_TO_POINT_RATIO = 0.5; // Start low
export const RATIO_INCREASE_INTERVAL = 5; // every 5 levels
export const RATIO_INCREASE_AMOUNT = 0.25;
export const MAX_PIXEL_TO_POINT_RATIO = 2.0; // Maximum penalty

// Timer
export const INITIAL_TIMER_MS = 3000;
export const TIMER_DECREASE_PER_LEVEL_MS = 200;
export const TIMER_SLOW_DECREASE_PER_LEVEL_MS = 10; // After hitting first threshold
export const TIMER_THRESHOLD_MS = 400; // When to switch to slow decrease
export const MIN_TIMER_MS = 200; // Absolute minimum

// Shapes
export const SHAPE_MIN_SIZE_PERCENT = 10;
export const SHAPE_MAX_SIZE_PERCENT = 90;
export const SHAPE_COLORS = [
  '#FF6B6B', // Red
  '#4ECDC4', // Cyan
  '#45B7D1', // Blue
  '#FFA07A', // Light Salmon
  '#98D8C8', // Mint
  '#F7DC6F', // Yellow
  '#BB8FCE', // Purple
];

// Animation
export const LEVEL_TRANSITION_DELAY_MS = 250;

// Particles
export const CLICK_PARTICLE_COUNT = 25;
export const CENTER_PARTICLE_COUNT = 40;
export const CLICK_PARTICLE_COLOR = '#FFD700'; // Gold
export const PARTICLE_BASE_SPEED = 300; // pixels/second - geometry wars style fast particles

// Particle fade curve (path-based — change these and everything adapts automatically)
export const PARTICLE_FADE_START_MS = 750;   // full opacity for this many ms
export const PARTICLE_FADE_DURATION_MS = 750; // then fades to 0 over this many ms
export const PARTICLE_LIFE_MS = PARTICLE_FADE_START_MS + PARTICLE_FADE_DURATION_MS + 50; // 1550ms total

// Hard cap on simultaneous particles. Oldest are dropped first.
export const PARTICLE_CAP = 3_000;

// Canvas background grid
export const BACKGROUND_GRID_SIZE = 50;
export const PROGRESS_BAR_HEIGHT = 10;

// Feedback messages
export const FEEDBACK_PERFECT = 'PERFECT!';
export const FEEDBACK_EXCELLENT = 'EXCELLENT!';
export const FEEDBACK_GOOD = 'GOOD JOB!';
export const FEEDBACK_NICE = 'NICE!';
export const FEEDBACK_CLOSE = 'CLOSE!';

// LocalStorage keys
export const HIGH_SCORE_KEY = 'precision-clicker-high-score';
export const SETTINGS_KEY = 'precision-clicker-settings';
